var _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetterOfCredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M1696.375,516.46c-367.687,6.156-936.571,138.66-1100.317,479.172 c-57.19,118.928-53.318,293.766-45.575,643.442c2.276,102.779,6.05,252.581,32.554,438.452 c55.057,386.113,92.537,648.964,234.387,802.018c355.434,383.507,1639.346,372.425,2187.613-318.013 c299.083-376.638,345.094-912.419,71.618-1355.214C2775.563,718.808,2188.621,508.219,1696.375,516.46z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1486.096,2739.98c135.747-89.115,320.684-240.046,434.19-479.271 c148.859-313.74,44.066-503.691,156.535-1059.21c71.113-351.249,124.28-595.663,325.174-696.307 c157.43-78.869,386.732-60.006,507.037,59.543c100.03,99.402,136.416,280.052,135.459,404.303 c-0.78,101.264-26.407,170.417,21.274,232.15c48.729,63.09,116.542,44.016,163.903,92.71 c96.046,98.751-13.59,351.228-31.309,392.033c-197.107,453.908-689.496,697.33-905.558,800.924 C2114.157,2572.511,1842.039,2680.708,1486.096,2739.98z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139256613540511473710000003504664293104995717_",
    gradientUnits: "userSpaceOnUse",
    x1: 1714.3861,
    y1: 1023.6422,
    x2: 2104.9238,
    y2: 1530.0541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      opacity: 0.74,
      fill: "url(#SVGID_00000139256613540511473710000003504664293104995717_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085249377694952776970000011769387955494530441_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      opacity: 0.74
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000085249377694952776970000011769387955494530441_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1337.252,2802.909l-1.337-6.929c216.124-41.659,406.542-103.072,565.965-182.53 c235.204-117.229,395.705-270.82,477.036-456.504c63.682-145.396,77.94-304.92,97.67-525.708 c15.747-176.257,11.012-302.57,6.833-414.014c-5.451-145.463-9.761-260.358,34.711-418.125 c45.138-160.127,127.175-312.832,243.827-453.873l5.437,4.497c-116.021,140.279-197.6,292.115-242.469,451.29 c-44.173,156.699-39.883,271.104-34.453,415.947c4.187,111.653,8.928,238.204-6.857,414.886 c-19.048,213.143-34.088,381.48-98.235,527.931c-82.013,187.239-243.627,342.002-480.353,459.989 C1745.032,2699.51,1554.005,2761.128,1337.252,2802.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2490.093,1505.504l-3.329-2.198c-1.061-0.703-107.456-71.9-202.038-210.657 c-55.554-81.493-96.271-170.034-121.024-263.165c-30.938-116.4-36.879-240.313-17.659-368.3l6.981,1.048 c-19.068,126.958-13.197,249.848,17.449,365.255c24.519,92.331,64.864,180.124,119.915,260.942 c84.494,124.037,178.408,193.621,196.987,206.72c149.578-298.27,352.788-466.063,497.202-554.398 c157.207-96.159,280.757-121.55,281.988-121.795l1.378,6.921c-1.22,0.243-123.778,25.472-279.968,121.071 c-144.121,88.209-347.175,256.098-496.103,554.989L2490.093,1505.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2435.555,1980.767l-1.061-2.335c-0.848-1.863-86.1-188.308-208.158-358.498 c-121.61-169.562-456.151-279.409-459.515-280.499l2.174-6.714c3.387,1.097,340.131,111.673,463.074,283.1 c115.04,160.4,197.476,335.164,207.769,357.348c197.652-24.06,435.704-247.532,600.912-431.209 c180.076-200.211,314.821-397.658,316.161-399.629l5.837,3.968c-1.344,1.974-136.316,199.761-316.699,400.323 c-105.998,117.852-206.721,213.612-299.377,284.619c-116.118,88.99-219.935,139.2-308.57,149.238L2435.555,1980.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2029.501,2588.243c-31.834,0-49.766-0.914-50.32-0.944l-7.019-0.382l4.5-5.401 c66.122-79.3,100.823-168.2,103.145-264.235c1.861-76.936-16.921-158.656-55.823-242.89 c-66.356-143.684-169.546-246.006-170.581-247.024l4.948-5.032c1.042,1.026,105.149,104.256,172.039,249.097 c39.36,85.222,58.359,167.995,56.471,246.019c-2.305,95.448-36.035,183.929-100.254,263.087 c34.997,1.208,196.829,4.31,408.022-30.39c219.546-36.073,538.863-121.546,813.328-323.893l532.527-392.602l4.19,5.68 l-532.526,392.602c-275.654,203.221-596.195,289.017-816.561,325.207C2232.311,2583.957,2098.389,2588.243,2029.501,2588.243z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122716758339111014410000016757469844429717948_",
    gradientUnits: "userSpaceOnUse",
    x1: 3560.1589,
    y1: 1945.7246,
    x2: 2470.0969,
    y2: 2401.323,
    gradientTransform: "matrix(0.9956 0.0937 -0.0937 0.9956 397.6632 -139.7934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122716758339111014410000016757469844429717948_)"
    },
    d: "M1987.614,3057.647 c189.314,56.987,432.9-7.692,693.937-59.647c66.617-13.259,518.732,61.581,522.348-141.133 c1.273-71.407-84.356-147.853-84.122-243.319c0.278-113.119,71.241-148.892,143.8-268.734 c43.295-71.509,170-280.782,80.838-443.286c-53.281-97.108-181.237-173.122-292.196-175.814 c-162.753-3.948-257.046,150.625-412.672,415.196c-137.956,234.533-134.189,303.118-236.085,470.102 C2327.838,2734.941,2202.398,2899.327,1987.614,3057.647z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000145773957436569403400000000200738934178416529_",
    d: "M1987.614,3057.647 c189.314,56.987,432.9-7.692,693.937-59.647c66.617-13.259,518.329,69.704,521.945-133.011 c1.273-71.407-83.953-155.975-83.718-251.441c0.278-113.119,71.241-148.892,143.8-268.734 c43.295-71.509,170-280.782,80.838-443.286c-53.281-97.108-181.237-173.122-292.196-175.814 c-162.753-3.948-257.046,150.625-412.672,415.196c-137.956,234.533-134.189,303.118-236.085,470.102 C2327.838,2734.941,2202.398,2899.327,1987.614,3057.647z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120525163780845071550000003622924197396803252_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145773957436569403400000000200738934178416529_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000120525163780845071550000003622924197396803252_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1774.915,3077.354c-5.165,0-10.332-0.041-15.505-0.122 c-205.151-3.251-407.169-68.143-600.44-192.872l3.826-5.928c192.146,124.002,392.913,188.515,596.725,191.744 c5.122,0.081,10.27,0.122,15.385,0.122c266.12,0.008,524.253-109.565,767.546-325.844 c258.299-229.615,435.115-521.947,537.964-726.749c71.283-141.946,106.081-312.009,103.424-505.467l7.057-0.097 c2.67,194.601-32.379,365.762-104.176,508.73c-103.124,205.354-280.447,498.498-539.58,728.857 C2302.526,2967.181,2042.797,3077.353,1774.915,3077.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2844.332,2414.777l-1.254-3.281c-0.348-0.906-34.873-92.139-49.397-220.288 c-13.414-118.351-12.049-293.38,70.608-455.119l6.285,3.211c-81.827,160.109-83.177,333.582-69.905,450.915 c12.863,113.687,41.551,198.06,47.788,215.455c476.394-181.485,556.598-525.322,569.839-626.572 c0.396-3.034,0.541-4.119,0.72-4.817l6.836,1.745l-3.418-0.873l3.422,0.861c-0.124,0.528-0.286,1.881-0.565,3.998 c-13.396,102.469-94.652,450.988-577.671,633.522L2844.332,2414.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2904.031,2835.992c-96.681,0-216.241-22.186-356.455-89.574l-1.681-0.809l-0.279-1.845 c-0.444-2.962-43.356-300.311,69.226-654.667l113.641-357.672l6.726,2.136l-113.64,357.672 c-107.445,338.181-72.668,624.063-69.23,649.641c130.431,62.408,325.644,123.68,518.227,63.636 c115.449-35.994,175.796-99.385,176.392-100.021l5.148,4.825c-0.606,0.65-62.231,65.391-179.438,101.933 C3028.205,2825.11,2971.717,2835.992,2904.031,2835.992z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039840836630031233140000016498590018235164811_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.7784,
    y1: 2166.1399,
    x2: 3152.7476,
    y2: 2166.1399,
    gradientTransform: "matrix(1 0 -0.2009 1.0457 646.8453 -147.4554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039840836630031233140000016498590018235164811_)"
    },
    d: "M2334.897,1027.045l-1670.253,152.69 c100.911,62.339,257.078,187.287,351.08,440.429c185.073,498.388-20.55,962.602,201.881,1297.824 c59.182,89.193,186.791,250.725,383.936,290.32l1595.125-217.478c-522.327-151.435-663.999-437.753-691.245-681.86 c-27.341-244.977,50.453-537.991-42.736-932.281C2424.577,1215.448,2372.567,1099.438,2334.897,1027.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M861.71,755.221c490.471-30.796,980.941-61.592,1471.411-92.389 c66.031,55.95,158.778,155.418,219.209,327.474c139.081,395.98-22.924,787.615,23.888,1172.507 c29.853,245.449,152.996,552.95,594.088,758.488c-526.676,68.922-1053.352,137.841-1580.028,206.762 c-108.821-41.686-253.865-128.333-337.793-329.939c-88.979-213.745-26.68-358.337-57.335-1030.214 c-21.574-472.851-64.007-659.347-152.394-808.856C981.558,855.536,912.583,792.832,861.71,755.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M871.119,755.221c490.471-30.796,980.941-61.592,1471.411-92.389 c66.031,55.95,158.778,155.418,219.209,327.474c139.081,395.98-22.923,787.615,23.888,1172.507 c29.853,245.449,152.996,552.95,594.088,758.488c-526.676,68.922-1053.352,137.841-1580.029,206.762 c-108.821-41.686-253.865-128.333-337.793-329.939c-88.979-213.745-26.68-358.337-57.335-1030.214 c-21.574-472.851-64.007-659.347-152.394-808.856C990.967,855.536,921.992,792.832,871.119,755.221z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2478.929,2126.622c0.313,3.876,0.641,7.752,0.99,11.63c0.328,3.65-2.305,6.894-5.948,7.294 l-1150.47,126.359c-4.007,0.44-7.497-2.689-7.461-6.72c0.036-3.902,0.069-7.839,0.102-11.809c0.027-3.41,2.601-6.29,5.991-6.662 l1149.369-126.24C2475.273,2120.059,2478.625,2122.841,2478.929,2126.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2474.328,2002.789c-0.012,3.916-0.012,7.833,0.002,11.751c0.012,3.449-2.573,6.349-6.003,6.715 l-1144.469,121.887c-3.965,0.422-7.422-2.651-7.438-6.638c-0.016-3.902-0.035-7.833-0.056-11.789 c-0.019-3.454,2.579-6.381,6.013-6.747l1144.521-121.894C2470.884,1995.651,2474.341,1998.782,2474.328,2002.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2495.365,2249.189c0.727,3.835,1.474,7.66,2.239,11.474c0.776,3.867-1.903,7.563-5.823,8.006 l-1169.832,132.279c-4.022,0.455-7.533-2.715-7.483-6.762c0.048-3.895,0.097-7.829,0.149-11.814 c0.044-3.39,2.603-6.235,5.972-6.616l1167.43-132.009C2491.515,2243.353,2494.71,2245.73,2495.365,2249.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2304.03,2896.253l530.497-67.946c2.279-0.291,4.572,0.603,6.062,2.441 c2.848,3.514,6.373,6.281,10.347,8.441c6.104,3.319,4.158,11.878-2.17,12.689l-520.617,66.68 C2320.105,2911.127,2312.064,2903.695,2304.03,2896.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M1573.548,2989.813l599.191-76.745c7.762,7.514,15.579,14.971,23.433,22.393l-602.573,77.178 c-1.323,0.169-2.678-0.054-3.875-0.643c-6.307-3.099-12.502-6.307-18.591-9.617 C1565.423,2999.274,1567.101,2990.638,1573.548,2989.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2478.639,1878.08c-0.246,3.954-0.483,7.911-0.71,11.87c-0.189,3.289-2.727,5.956-6.004,6.293 l-1149.542,118.49c-3.917,0.404-7.339-2.609-7.414-6.547c-0.074-3.898-0.15-7.818-0.23-11.762 c-0.071-3.5,2.552-6.489,6.034-6.848l1150.487-118.588C2475.388,1870.564,2478.896,1873.937,2478.639,1878.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2637.554,2605.917c2.386,3.629,4.802,7.241,7.243,10.84c2.831,4.174,0.284,9.855-4.722,10.467 l-1267.926,155.078c-2.904,0.355-5.719-1.193-6.939-3.853c-1.714-3.732-3.397-7.499-5.05-11.302 c-1.8-4.143,0.852-8.855,5.336-9.404l1265.654-154.801C2633.679,2602.633,2636.153,2603.787,2637.554,2605.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2572.295,2489.234c1.742,3.712,3.506,7.411,5.293,11.098c2.021,4.168-0.631,9.076-5.23,9.625 l-1239.655,147.902c-3.532,0.422-6.808-1.969-7.428-5.472c-0.69-3.899-1.339-7.828-1.953-11.79 c-0.58-3.751,2.095-7.237,5.864-7.687l1236.244-147.497C2568.306,2485.07,2571.065,2486.613,2572.295,2489.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2525.783,2370.177c1.198,3.779,2.417,7.545,3.658,11.3c1.339,4.052-1.352,8.303-5.591,8.796 l-1201.978,139.712c-3.933,0.457-7.419-2.557-7.505-6.516c-0.084-3.895-0.156-7.843-0.217-11.841 c-0.053-3.452,2.524-6.397,5.954-6.796l1198.508-139.309C2521.811,2365.152,2524.809,2367.108,2525.783,2370.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2488.666,1752.953c-0.373,3.964-0.742,7.93-1.107,11.9c-0.295,3.207-2.819,5.758-6.024,6.077 l-1162.52,115.74c-3.871,0.385-7.259-2.569-7.388-6.457c-0.129-3.893-0.262-7.804-0.397-11.736 c-0.123-3.545,2.525-6.594,6.054-6.946l1164.026-115.89C2485.521,1745.223,2489.062,1748.74,2488.666,1752.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2453.973,1008.381c2.991-0.228,5.781,1.545,6.824,4.357c1.42,3.827,2.821,7.673,4.184,11.554 c0.01,0.028,0.02,0.055,0.029,0.083c1.455,4.148-1.476,8.541-5.859,8.875l-1222.098,93.09c-3.201,0.244-6.12-1.834-6.98-4.927 c-1.07-3.846-2.152-7.661-3.248-11.444c-1.189-4.105,1.676-8.241,5.937-8.566L2453.973,1008.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2495.304,1133.464c0.811,3.889,1.593,7.78,2.351,11.672c0.767,3.937-2.087,7.665-6.085,7.986 l-1226.135,98.536c-3.444,0.277-6.531-2.127-7.15-5.526c-0.706-3.878-1.421-7.726-2.144-11.545 c-0.744-3.931,2.076-7.616,6.064-7.937l1225.949-98.521C2491.534,1127.858,2494.612,1130.144,2495.304,1133.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2401.839,908.493l-1208.999,91.909c-2.849,0.217-5.513-1.41-6.654-4.029 c-13.741-31.531-28.926-61.07-45.739-89.509c-8.472-14.331-17.29-28.28-26.422-41.874c-2.9-4.317-0.082-10.148,5.106-10.498 l1189.724-80.176c1.964-0.132,3.896,0.592,5.279,1.993c35.453,35.927,66.519,76.712,93.037,122.113 C2409.667,902.696,2406.774,908.118,2401.839,908.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2500.906,1627.779c-0.384,3.964-0.77,7.932-1.159,11.903c-0.313,3.204-2.855,5.747-6.059,6.055 l-1179.819,113.188c-3.827,0.367-7.182-2.559-7.361-6.4c-0.184-3.927-0.369-7.834-0.556-11.725 c-0.172-3.587,2.502-6.663,6.076-7.005l1181.532-113.353C2497.773,1620.037,2501.314,1623.566,2500.906,1627.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2511.622,1502.95c-0.276,3.952-0.56,7.906-0.852,11.864c-0.242,3.285-2.833,5.925-6.112,6.227 l-1197.716,110.445c-3.777,0.348-7.094-2.511-7.331-6.297c-0.245-3.921-0.493-7.822-0.743-11.703 c-0.234-3.636,2.467-6.78,6.094-7.114l1199.306-110.591C2508.404,1495.399,2511.911,1498.808,2511.622,1502.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2516.925,1378.754c-0.041,3.946-0.098,7.894-0.167,11.845c-0.061,3.441-2.718,6.283-6.146,6.586 l-1213.064,107.209c-3.706,0.328-6.971-2.436-7.292-6.143c-0.338-3.911-0.68-7.799-1.026-11.665 c-0.331-3.703,2.402-6.954,6.106-7.282l1214.256-107.316C2513.553,1371.639,2516.967,1374.779,2516.925,1378.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2512.798,1255.518c0.323,3.921,0.623,7.844,0.905,11.769c0.264,3.673-2.491,6.876-6.16,7.186 l-1223.127,103.272c-3.602,0.304-6.795-2.317-7.238-5.905c-0.482-3.899-0.97-7.768-1.462-11.613 c-0.486-3.799,2.287-7.217,6.103-7.54l1223.689-103.318C2509.215,1249.057,2512.493,1251.811,2512.798,1255.518z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC79AB"
    },
    d: "M2794.854,2890.053l-212.432-131.572c-70.605-44.127-141.424-88.053-210.638-134.034 c-17.177-11.556-34.573-23.194-50.527-35.632c-1.952-1.557-3.879-3.136-5.605-4.695c-0.856-0.773-1.671-1.555-2.298-2.229 c-0.281-0.311-0.559-0.638-0.62-0.738c-0.109-0.126,0.088,0.088,0.091,0.174c0.142,0.24,0.253,0.506,0.327,0.777 c0.107,0.284,0.383,1.425,0.297,2.119c0.081,1.237-0.636,3.159-1.411,4.134c-0.989,1.288-2.036,1.854-2.346,2.022 c-0.701,0.334-1.044,0.413-1.142,0.455c-0.184,0.06-0.502,0.09-0.453,0.097c-0.088,0.023-0.153,0.007,0.009,0.018 c0.067-0.005,0.228,0.002,0.429,0.019c0.754,0.054,1.797,0.188,2.885,0.402c2.168,0.399,4.522,1.007,6.852,1.667 c9.396,2.718,18.839,6.485,27.965,10.698c18.252,8.504,35.659,19.09,50.646,32.034c14.898,12.888,27.462,28.562,33.028,46.322 c5.884,17.772,3.231,36.628-5.331,53.826c-8.478,17.345-21.449,33.116-34.371,49.592c-6.473,8.26-13.005,16.779-18.833,26.278 c-5.802,9.411-11.018,20.151-12.976,32.489c-1.031,6.144-0.796,12.621,0.225,18.869c0.675,3.094,1.334,6.206,2.507,9.098 c0.952,3.01,2.333,5.754,3.737,8.492c5.71,10.925,14.009,19.49,22.794,26.691c17.804,14.286,38.138,23.414,58.846,29.969 c20.759,6.566,42.172,10.352,63.706,11.965c43.01,3.145,87.063-2.646,127.473-19.645c20.2-8.595,38.9-20.105,55.991-33.401 c17.092-13.334,32.71-28.485,46.338-45.575c6.784-8.574,13.126-17.591,18.507-27.466c5.345-9.867,10.073-20.434,12.101-32.828 c0.956-6.174,1.209-12.958-0.597-20.07c-0.494-1.775-0.945-3.541-1.782-5.281l-1.165-2.601c-0.462-0.898-1.117-1.884-1.703-2.799 c-2.456-3.676-6.018-6.847-9.613-8.72c-7.332-3.997-14.047-4.581-20.118-4.943c-6.107-0.263-11.807,0.197-17.315,0.856 c-21.959,2.732-42.089,8.203-62.349,13.41c-20.142,5.487-40.144,10.992-60.255,16.068c-20.093,5.13-40.286,9.758-60.626,13.856 c-20.371,3.864-40.852,7.223-61.446,9.739c-41.183,5.008-82.65,7.78-124.117,8.051c-41.458,0.376-82.933-1.717-124.04-6.657 l-0.023-0.003c-5.93-0.712-11.315,3.518-12.029,9.448c-0.712,5.93,3.518,11.313,9.448,12.027 c0.418,0.051,0.843,0.076,1.254,0.077c42.035,0.137,83.929-0.262,125.739-2.291c20.894-1.128,41.784-2.189,62.611-4.104 c10.425-0.792,20.828-1.836,31.238-2.781c10.386-1.181,20.796-2.158,31.157-3.544c41.487-5.051,83.007-10.556,124.258-17.966 c20.608-3.69,41.13-7.822,61.531-11.872c10.187-2.07,20.311-4.261,30.391-6.155c10.057-1.878,20.063-3.835,29.741-4.814 c4.832-0.532,9.558-0.726,13.857-0.58c4.25,0.142,8.205,0.915,10.02,2.056c2.648,0.531,5.032,7.993,3.51,16.121 c-1.272,8.221-4.957,17.076-9.532,25.445c-4.56,8.437-10.214,16.542-16.332,24.3c-12.304,15.509-26.749,29.609-42.469,41.91 c-15.745,12.297-32.805,22.808-50.938,30.563c-36.465,15.481-77.25,20.91-117.201,18.438 c-19.99-1.316-39.904-4.674-58.913-10.512c-18.96-5.765-37.319-14.044-52.155-25.786c-14.863-11.591-25.11-27.629-22.337-44.104 c1.223-8.304,4.99-16.854,10.036-25.129c4.993-8.309,11.052-16.43,17.312-24.637c12.475-16.41,26.165-33.149,35.841-53.457 c4.856-10.075,8.296-21.297,9.44-32.93c1.2-11.644-0.267-23.565-3.925-34.51c-3.602-11.008-9.286-21.063-16.038-29.985 c-6.754-8.952-14.573-16.836-22.92-23.885c-16.748-14.083-35.448-25.071-55.019-33.91c-9.834-4.384-19.831-8.26-30.482-11.205 c-2.688-0.722-5.389-1.397-8.346-1.908c-1.472-0.26-3.013-0.476-4.858-0.58c-0.45-0.026-0.938-0.044-1.521-0.026 c-0.49-0.005-1.202,0.046-1.938,0.142c-0.278,0.021-0.908,0.153-1.409,0.285c-0.422,0.1-1.072,0.278-2.056,0.778 c-0.627,0.278-1.915,1.056-3.114,2.602c-1.026,1.191-1.732,3.497-1.73,5.029c-0.025,1.01,0.246,2.488,0.472,3.075 c0.198,0.571,0.438,1.135,0.705,1.676c0.357,0.633,0.845,1.434,1.151,1.81c0.705,0.954,1.3,1.597,1.898,2.244 c1.163,1.218,2.252,2.214,3.336,3.173c2.163,1.905,4.291,3.596,6.429,5.259c17.069,12.962,34.492,24.261,52.002,35.74 c35.042,22.741,70.451,44.725,105.939,66.589c35.508,21.826,71.091,43.505,106.828,64.925 c71.484,42.817,142.959,85.623,215.053,127.391c1.594,0.93,3.637,0.39,4.566-1.202 C2796.892,2893.012,2796.378,2891.006,2794.854,2890.053z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117638538617897026320000012078009400468740753_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.3333,
    y1: 3130.3604,
    x2: 347.891,
    y2: 3455.6392,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117638538617897026320000012078009400468740753_)"
    },
    d: "M1150.938,3292.584 c0,0,102.881,46.758,104.561,54.222c1.68,7.464-66.163-2.502-93.859-1.426c-27.696,1.078-50.479-7.108-47.972-18.839 c2.508-11.731,12.202-41.236,12.202-41.236L1150.938,3292.584z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145035604989893163970000005639923262355870892_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.3134,
    y1: 3311.4539,
    x2: 383.6668,
    y2: 2974.561,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145035604989893163970000005639923262355870892_)"
    },
    d: "M1154.702,3254.637l-6.258,46.32 c0,0-16.288,5.798-27.229-1.057l-4.667-50.803L1154.702,3254.637z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091001354714125053160000000652678307563618437_",
    gradientUnits: "userSpaceOnUse",
    x1: 805.317,
    y1: 3092.4131,
    x2: 830.8746,
    y2: 3417.6902,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091001354714125053160000000652678307563618437_)"
    },
    d: "M670.199,3255.748l-11.966,19.21 c-3.347,5.373-4.344,11.841-2.739,17.964c4.185,15.976,12.542,47.108,16.186,55.227c4.963,11.058,71.541,17.626,71.541,17.626 s5.936-8.354-7.888-18.446c-13.822-10.09-22.706-11.678-27.586-26.569c-4.878-14.89-8.133-57.01-8.133-57.01L670.199,3255.748z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031904798261709984040000001118443459461383346_",
    gradientUnits: "userSpaceOnUse",
    x1: 830.9467,
    y1: 3305.3496,
    x2: 826.3,
    y2: 2968.4512,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031904798261709984040000001118443459461383346_)"
    },
    d: "M720.008,3206.928 c-4.37,3.485-25.754,68.388-25.754,68.388s-6.922,8.851-20.07-4.212c-13.147-13.062-5.95-5.859-5.95-5.859l2.464-63.833 L720.008,3206.928z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063623899221177818330000015440346630147734188_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.9129,
    y1: 2765.6934,
    x2: 557.0043,
    y2: 2765.6934,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063623899221177818330000015440346630147734188_)"
    },
    d: "M1211.307,2324.025 c5.427,138.174,5.649,288.292-2.302,448.666c-8.951,180.593-26.94,347.505-49.61,498.811c-8.427,0.269-17.284,0.314-26.533,0.054 c-6.247-0.174-12.3-0.478-18.149-0.883c-11.764-31.373-25.67-72.631-38.122-121.913c-13.091-51.82-20.989-98.302-26.615-142.75 c-19.812-156.502,3.406-170.155-12.673-286.137c-14.239-102.719-34.489-106.73-58.262-252.569 c-25.793-158.24-6.591-181.979,2.746-190.556C1021.538,2240.241,1114.908,2265.095,1211.307,2324.025z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029009734506453467050000014717563892523657903_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.9122,
    y1: 2765.7041,
    x2: 557.0024,
    y2: 2765.7041,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000029009734506453467050000014717563892523657903_)"
    },
    d: "M981.788,2276.751 c37.912-34.823,124.617-13.743,216.192,39.406c-105.35,113.822-116.834,187.659-104.205,235.567 c14.274,54.148,57.669,69.743,57.505,128.95c-0.204,72.761-65.87,92.035-64.475,169.029 c0.923,50.912,29.778,50.384,36.594,113.267c8.062,74.402-29.636,100.04-17.426,155.088 c5.253,23.683,20.246,54.629,62.947,86.508c-3.079,22.606-6.235,44.983-9.525,66.939c-8.424,0.265-17.282,0.312-26.532,0.05 c-6.247-0.173-12.301-0.475-18.148-0.881c-11.766-31.373-25.671-72.63-38.123-121.911 c-13.091-51.821-20.989-98.302-26.615-142.751c-19.811-156.5,3.406-170.155-12.673-286.137 c-14.239-102.719-34.489-106.733-58.26-252.57C953.25,2309.064,972.45,2285.324,981.788,2276.751z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171713386412894179810000017854740461263366063_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.0647,
    y1: 2741.1396,
    x2: 878.5125,
    y2: 2741.1396,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171713386412894179810000017854740461263366063_)"
    },
    d: "M1146.052,2321.705 c-90.711,132.728-188.551,297.913-276.05,495.633c-66.124,149.419-114.081,289.709-149.29,414.738 c-4.765,2.205-16.004,6.606-30.365,4.708c-19.589-2.59-31.33-15.095-34.398-18.584c-14.331-89.629-12.751-165.537-7.888-220.322 c3.115-35.076,8.627-93.489,30.985-165.601c25.042-80.774,42.259-85.315,74.93-170.771 c33.91-88.701,25.697-110.837,58.171-221.841c13.34-45.6,35.672-113.461,72.521-194.632 C971.795,2270.588,1058.923,2296.148,1146.052,2321.705z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052822575847449350880000014400629435983264655_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.2254,
    y1: 2338.4312,
    x2: 501.4524,
    y2: 1833.087,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052822575847449350880000014400629435983264655_)"
    },
    d: "M1564.848,2490.151 c-17.447,27.13-77.486,23.957-118.494,9.296c-95.879-34.284-157.24-156.222-162.64-253.255 c-1.16-20.835-0.425-41.203-4.646-41.822c-10.621-1.563-37.899,124.409-59.309,231.21c-17.211,6.3-43.306,12.99-73.126,8.104 c-48.807-7.995-54.616-38.317-109.202-58.087c-31.848-11.534-63.053-11.561-125.465-11.615 c-70.454-0.061-72.396,8.628-85.966,2.324c-25.112-11.664-54.694-58.243,94.688-636.891 c9.818-38.032,26.369-98.842,72.618-116.544c37.88-14.498,86.58,12.481,182.433,67.027 c47.896,27.258,101.421,58.107,164.225,112.957c42.778,37.363,72.559,63.372,97.096,99.473 c98.941,145.575-15.407,266.898,74.349,453.067C1542.272,2419.407,1583.118,2461.743,1564.848,2490.151z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172406597998209231880000009961692355069765017_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.9858,
    y1: 2360.2212,
    x2: 562.2121,
    y2: 1854.8794,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000172406597998209231880000009961692355069765017_)"
    },
    d: "M935.201,2297.309 c28.032-14.592,20.944-45.226,45.307-62.732c36.316-26.098,80.615,21.471,128.95,13.94 c105.487-16.436,116.165-277.525,184.712-278.81c32.257-0.606,63.365,56.698,73.188,101.069 c17.186,77.642-48.622,112.28-38.337,209.108c1.844,17.367,3.785,14.58,48.792,142.89c5.987,17.072,11.476,32.863,16.437,47.239 c-65.593-51.701-106.192-145.776-110.536-223.821c-1.16-20.835-0.425-41.203-4.646-41.822 c-10.621-1.563-37.899,124.409-59.309,231.21c-17.211,6.3-43.306,12.99-73.126,8.104c-48.807-7.995-54.616-38.317-109.202-58.087 c-31.848-11.534-63.053-11.561-125.465-11.615c-70.454-0.061-72.396,8.628-85.966,2.324 c-10.277-4.775-21.284-15.454-20.486-66.003c20.714-12.885,38.498-16.602,53.013-16.479 C888.294,2294.079,910.045,2310.402,935.201,2297.309z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008130875622707969900000015270266141879631523_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.7288,
    y1: 1850.3403,
    x2: 291.7288,
    y2: 1649.0732,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008130875622707969900000015270266141879631523_)"
    },
    d: "M1298.823,1663.662 c0,0-25.759,29.247-53.445,44.405c-25.02,13.698-80.176-9.375-92.937-12.085c-12.761-2.71,2.551,31.653,26.627,55.337 c24.075,23.682,103.656,77.848,125.121,78.754c21.463,0.907-3.457-17.89-16.637-39.778c-13.181-21.887,5.394-67.137,22.03-81.081 C1326.219,1695.27,1298.823,1663.662,1298.823,1663.662z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M539.885,1801.656l421.738,281.332c11.952,7.973,30.351,1.38,41.094-14.725l0,0 c10.743-16.105,9.764-35.624-2.189-43.598l-421.739-281.332c-11.952-7.973-30.35-1.38-41.094,14.725l0,0 C526.952,1774.163,527.933,1793.682,539.885,1801.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M461.393,1665.021l91.987,61.363l47.565-71.303l-91.988-61.364 c-1.692-1.129-3.979-0.672-5.107,1.02l-43.477,65.177C459.245,1661.606,459.702,1663.893,461.393,1665.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M2180.767,2782.536l39.326,26.233c4.424,2.951,11.234,0.51,15.21-5.45l0,0 c3.977-5.962,3.615-13.186-0.81-16.137l-39.326-26.233L2180.767,2782.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2210.675,2786.89L2210.675,2786.89c-7.291,10.929-19.277,16.552-28.695,13.459l-194.366-63.841 l90.869-136.219l133.598,154.937C2218.554,2762.734,2217.967,2775.96,2210.675,2786.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2206.23,2770.25L2206.23,2770.25c-1.997,2.993-9.418,1.773-17.767-2.923l-159.86-115.568 l24.888-37.309l143.217,140.519C2204.249,2760.872,2208.227,2767.257,2206.23,2770.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072277611715342356350000000543957053607850653_",
    gradientUnits: "userSpaceOnUse",
    x1: -39.296,
    y1: 1117.0522,
    x2: 115.3928,
    y2: 1693.1357,
    gradientTransform: "matrix(-0.6173 -0.4118 -0.5549 0.8319 2158.2368 966.2356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072277611715342356350000000543957053607850653_)"
    },
    d: "M525.36,1757.441l1466.216,981.711 c27.917,18.622,118.785-117.598,90.87-136.22L616.229,1621.221c-16.653-11.108-42.287-1.923-57.256,20.516l-36.664,54.962 C507.341,1719.137,508.707,1746.332,525.36,1757.441z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "897.637,1891.764 2049.902,2664.044 2071.317,2631.941 919.052,1859.66  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093866382315304804960000004942583831585751172_",
    gradientUnits: "userSpaceOnUse",
    x1: 715.0003,
    y1: 1482.8226,
    x2: 736.77,
    y2: 1482.8226,
    gradientTransform: "matrix(-0.6173 -0.4118 -0.5549 0.8319 2158.2368 966.2356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000093866382315304804960000004942583831585751172_)"
    },
    points: "834.997,1964.776  848.432,1973.737 939.662,1836.976 926.229,1828.015  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.362,
    y: 1613.288,
    transform: "matrix(-0.8319 -0.5549 0.5549 -0.8319 120.6159 3427.5098)",
    style: {
      fill: "#FFFFFF"
    },
    width: 16.148,
    height: 164.397
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044165814490773663300000010699708660937868220_",
    gradientUnits: "userSpaceOnUse",
    x1: -39.7787,
    y1: 1115.2468,
    x2: 115.2878,
    y2: 1692.7372,
    gradientTransform: "matrix(-0.6173 -0.4118 -0.5549 0.8319 2158.2368 966.2356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000044165814490773663300000010699708660937868220_)"
    },
    d: "M616.229,1621.221 l701.847,471.816c27.081,146.189,77.686,192.835,124.81,204.061c32.726,7.793,83.371,3.202,134.31,43.057 c49.193,38.49,35.594,69.086,79.602,93.575c65.243,36.305,124.053-14.856,162.876,29.531 c20.877,23.869,5.699,40.753,26.073,88.629c7.554,17.759,39.023,91.7,116.768,103.746c45.22,7.006,89.639-9.484,123.52-28.265 c-10.774,44.149-72.344,126.533-94.46,111.78L525.36,1757.441c-16.652-11.109-18.018-38.303-3.049-60.743l36.664-54.962 C573.942,1619.298,599.576,1610.113,616.229,1621.221z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101821741716182005800000003865565810577684899_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.3502,
    y1: 2476.5564,
    x2: -33.616,
    y2: 2476.5564,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101821741716182005800000003865565810577684899_)"
    },
    d: "M1556.732,2448.19 c0,0,37.014,17.679,63.208,21.382c26.194,3.703,31.888,24.626,24.616,32.315c-7.27,7.688-48.956-0.732-62.897-8.573 C1567.719,2485.472,1556.732,2448.19,1556.732,2448.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059281579691792576070000003756330735272386229_",
    gradientUnits: "userSpaceOnUse",
    x1: 609.7031,
    y1: 2023.3082,
    x2: 720.3685,
    y2: 2023.3082,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059281579691792576070000003756330735272386229_)"
    },
    d: "M802.748,2014.732 c0,0,29.038-4.356,43.234,9.584c14.196,13.941,50.964,34.043,67.432,27.041l-58.075-39.128l-52.591-18.407V2014.732z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081621220215599098700000000633839238568903067_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.5791,
    y1: 2384.1045,
    x2: 628.8062,
    y2: 1878.7601,
    gradientTransform: "matrix(-1 0 0 1 1523.1162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081621220215599098700000000633839238568903067_)"
    },
    d: "M816.707,2032.439 c-21.163-0.722-107.512-6.063-171.933-74.349c-65.237-69.151-90.289-184.089-41.822-262.549 c38.698-62.647,109.96-78.878,182.962-95.508c95.219-21.69,169.996-5.214,199.875,2.88 c50.838,13.771,129.393,35.052,137.82,82.073c9.312,51.972-68.318,128.267-143.912,131.993 c-76.292,3.764-117.109-68.031-186.106-46.225c-4.683,1.48-37.805,12.446-53.37,41.824 c-24.566,46.372,3.259,122.296,75.809,183.137C816.256,2007.958,816.481,2020.197,816.707,2032.439z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132766759163956695270000017458341690058262678_",
    gradientUnits: "userSpaceOnUse",
    x1: -6527.9429,
    y1: -107.6867,
    x2: -6540.2397,
    y2: -255.2508,
    gradientTransform: "matrix(-0.4803 -0.8772 -0.8772 0.4803 -2006.7333 -3974.4402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132766759163956695270000017458341690058262678_)"
    },
    d: "M1336.91,1687.527 c22.566,0.51,24.282,4.36,34.946,2.028c24.301-5.312,45.637-31.924,40.606-43.399c-3.244-7.398-14.848-2.573-39.874-9.52 c-30.658-8.514-33.318-21.329-57.401-23.441c-5.633-0.495-30.988-2.716-42.276,11.544c-14.406,18.2-0.027,55.815,21.736,63.981 C1304.969,1692.593,1309.11,1686.9,1336.91,1687.527z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143613690451237990190000017205445451650936752_",
    gradientUnits: "userSpaceOnUse",
    x1: 9301.083,
    y1: 1379.2317,
    x2: 9417.0645,
    y2: 1501.4827,
    gradientTransform: "matrix(0.6508 0.7592 -0.7592 0.6508 -3677.0671 -6397.0112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143613690451237990190000017205445451650936752_)"
    },
    d: "M1283.293,1691.971 c0,0,0.936,27.941,27.089,40.542c23.416,11.281,55.323-37.5,46.967-56.394c-2.788-6.303-11.587-13.235-20.665-15.465 c-5.362-1.317-8.015-0.276-16.736-2.599c-8.04-2.141-9.583-4.039-12.708-3.451c-3.908,0.732-8.932,5.102-12.872,22.408 c-1.843-6.797-6.072-11.392-10.713-11.731c-0.74-0.053-2.887,0.126-4.661,1.231 C1272.569,1670.517,1273.678,1680.887,1283.293,1691.971z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063627730593862880030000014332848226238336183_",
    gradientUnits: "userSpaceOnUse",
    x1: 2451.2544,
    y1: 1724.5565,
    x2: 2145.679,
    y2: 1822.6249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063627730593862880030000014332848226238336183_)"
    },
    d: "M2803.037,1713.469 c0,141.76-110.848,253.276-252.524,248.925c-147.443-4.528-271.447-131.867-271.447-284.25 c0-152.383,124.004-263.002,271.447-247.649C2692.189,1445.247,2803.037,1571.708,2803.037,1713.469z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035504576363340037840000005956065446007239557_",
    gradientUnits: "userSpaceOnUse",
    x1: 2698.447,
    y1: 1420.3867,
    x2: 2425.6479,
    y2: 2022.2322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035504576363340037840000005956065446007239557_)"
    },
    d: "M2841.32,1701.245 c0,141.76-110.848,253.276-252.524,248.925c-147.443-4.528-271.448-131.866-271.448-284.25 c0-152.383,124.005-263.002,271.448-247.649C2730.472,1433.024,2841.32,1559.485,2841.32,1701.245z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094614753364553031440000000550135455712308150_",
    gradientUnits: "userSpaceOnUse",
    x1: 2648.2656,
    y1: 2055.8696,
    x2: 2595.6284,
    y2: 1768.3148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094614753364553031440000000550135455712308150_)"
    },
    d: "M2830.2,1700.495 c0,135.518-106.061,241.942-241.404,237.56c-140.596-4.553-258.641-126.078-258.641-271.272s118.045-250.802,258.641-236.398 C2724.139,1444.253,2830.2,1564.978,2830.2,1700.495z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132784874833364110320000009713263979653201077_",
    gradientUnits: "userSpaceOnUse",
    x1: 2536.6648,
    y1: 1590.4304,
    x2: 2753.5894,
    y2: 2050.9202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132784874833364110320000009713263979653201077_)"
    },
    d: "M2822.236,1699.959 c0,131.047-102.627,233.835-233.439,229.443c-135.713-4.557-249.52-121.93-249.52-262.003s113.806-242.101,249.52-228.359 C2719.608,1452.286,2822.236,1568.912,2822.236,1699.959z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015336839779987874410000014029114205435114936_",
    gradientUnits: "userSpaceOnUse",
    x1: 2528.0225,
    y1: 1491.3391,
    x2: 2637.0996,
    y2: 1900.141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015336839779987874410000014029114205435114936_)"
    },
    d: "M2587.457,1483.622L2587.457,1483.622 c6.962,0.662,12.596,6.928,12.596,13.998v24.128c13.919,1.554,27.858,3.974,41.817,7.254 c10.292,2.419,20.515,5.298,30.669,8.637c6.084,2,10.23,8.143,9.61,14.479l-2.963,30.255c-0.786,8.027-8.721,12.741-16.191,9.41 c-6.688-2.983-13.546-5.538-20.574-7.664c-12.265-3.711-25.198-6.13-38.808-7.252l-3.559-0.293v69.099 c36.313,10.159,62.981,23.827,80.216,41.018c17.152,17.109,25.697,38.431,25.697,64.028c0,27.682-9.448,49.847-28.418,66.565 c-19.072,16.806-45.811,26.258-80.389,28.305v26.63c0,7.073-5.638,12.581-12.605,12.305l-0.223-0.009 c-6.981-0.278-12.65-6.256-12.65-13.353v-26.27l-5.612-0.253c-16.21-0.731-31.737-2.385-46.572-4.965 c-10.986-1.911-21.715-4.378-32.183-7.402c-6.331-1.829-10.677-7.86-10.096-14.339l3.487-38.893 c0.753-8.408,9.199-13.3,17.194-10.147c9.319,3.676,18.754,6.772,28.305,9.291c14.883,3.925,29.968,6.442,45.253,7.56 l0.224-76.863c-34.857-8.625-60.953-21.4-78.099-38.321c-17.226-17.001-25.869-38.758-25.869-65.212 c0-27.376,9.372-48.508,28.045-63.339c18.578-14.756,44.989-22.097,79.061-22.078v-24.667 C2574.817,1488.171,2580.481,1482.959,2587.457,1483.622z M2574.817,1575.859c-10.772,0.784-19.173,3.742-25.186,8.88 c-6.022,5.146-9.037,12.062-9.037,20.742c0,8.223,2.789,15.096,8.36,20.614c5.563,5.509,14.191,9.907,25.863,13.194V1575.859z  M2597.158,1715.042v70.486c11.711,0.023,20.691-2.773,26.959-8.38c6.258-5.598,9.383-13.504,9.383-23.727 c0-9.321-2.904-17.051-8.72-23.199C2618.956,1724.065,2609.757,1719.006,2597.158,1715.042z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044154201074847642520000014808402468277621908_",
    gradientUnits: "userSpaceOnUse",
    x1: 2472.8462,
    y1: 1620.2311,
    x2: 2689.3333,
    y2: 2079.7915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000044154201074847642520000014808402468277621908_)"
    },
    d: "M2546.552,1732.05 c7.887-77.898,79.479-110.875,70.136-182.529c-5.759-44.163-39.232-81.382-76.572-110.442 c-113.26,11.878-200.84,105.66-200.84,228.32c0,140.074,113.807,257.447,249.52,262.003c13.177,0.442,26.046-0.242,38.56-1.883 C2573.458,1873.887,2539.777,1798.974,2546.552,1732.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171721036128854657950000004847357802960904067_",
    gradientUnits: "userSpaceOnUse",
    x1: 2617.092,
    y1: 1027.7786,
    x2: 2188.7913,
    y2: 1165.2332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171721036128854657950000004847357802960904067_)"
    },
    d: "M3110.157,1012.237 c0,198.694-155.367,354.997-353.943,348.899c-206.659-6.346-380.466-184.827-380.466-398.411 c0-213.583,173.807-368.629,380.466-347.11C2954.791,636.293,3110.157,813.543,3110.157,1012.237z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171717681098369075070000001900477342911199650_",
    gradientUnits: "userSpaceOnUse",
    x1: 2963.5623,
    y1: 601.448,
    x2: 2581.2017,
    y2: 1445.007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171717681098369075070000001900477342911199650_)"
    },
    d: "M3163.817,995.105 c0,198.694-155.367,354.996-353.943,348.898c-206.659-6.346-380.467-184.827-380.467-398.41 c0-213.584,173.807-368.629,380.467-347.11C3008.449,619.16,3163.817,796.411,3163.817,995.105z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075853716068083360700000013444644289177935293_",
    gradientUnits: "userSpaceOnUse",
    x1: 2893.2271,
    y1: 1492.1539,
    x2: 2819.4497,
    y2: 1089.1111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075853716068083360700000013444644289177935293_)"
    },
    d: "M3148.23,994.054 c0,189.945-148.657,339.111-338.357,332.969c-197.062-6.381-362.516-176.713-362.516-380.22s165.454-351.53,362.516-331.34 C2999.573,634.899,3148.23,804.11,3148.23,994.054z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110455875791373222370000011658223034351469980_",
    gradientUnits: "userSpaceOnUse",
    x1: 2736.8052,
    y1: 839.7847,
    x2: 3040.8511,
    y2: 1485.2164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110455875791373222370000011658223034351469980_)"
    },
    d: "M3137.067,993.302 c0,183.678-143.844,327.748-327.194,321.593c-190.219-6.387-349.732-170.899-349.732-367.229s159.513-339.334,349.732-320.073 C2993.223,646.159,3137.067,809.624,3137.067,993.302z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108292389071445645940000018128218937954861956_",
    gradientUnits: "userSpaceOnUse",
    x1: 2724.6917,
    y1: 700.8962,
    x2: 2877.5764,
    y2: 1273.8815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDB44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEF06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108292389071445645940000018128218937954861956_)"
    },
    d: "M2807.996,690.08L2807.996,690.08 c9.757,0.928,17.654,9.711,17.654,19.62v33.818c19.509,2.178,39.046,5.57,58.611,10.168c14.426,3.39,28.754,7.426,42.987,12.105 c8.528,2.804,14.339,11.414,13.469,20.294l-4.153,42.407c-1.102,11.251-12.224,17.858-22.694,13.19 c-9.375-4.181-18.987-7.762-28.838-10.743c-17.19-5.201-35.318-8.592-54.394-10.165l-4.988-0.411v96.85 c50.897,14.24,88.276,33.397,112.433,57.492c24.04,23.98,36.017,53.866,36.017,89.744c0,38.799-13.242,69.867-39.832,93.298 c-26.732,23.556-64.21,36.804-112.675,39.673v37.326c0,9.913-7.903,17.635-17.668,17.246l-0.313-0.012 c-9.785-0.389-17.731-8.769-17.731-18.716v-36.82l-7.865-0.355c-22.72-1.025-44.483-3.343-65.276-6.959 c-15.399-2.679-30.436-6.136-45.109-10.375c-8.874-2.563-14.965-11.016-14.151-20.098l4.887-54.513 c1.056-11.785,12.893-18.642,24.099-14.222c13.062,5.152,26.286,9.492,39.672,13.022c20.86,5.501,42.004,9.03,63.427,10.597 l0.314-107.733c-48.856-12.089-85.433-29.995-109.465-53.712c-24.144-23.829-36.258-54.325-36.258-91.402 c0-38.371,13.136-67.99,39.309-88.777c26.04-20.682,63.057-30.971,110.813-30.945v-34.574 C2790.281,696.456,2798.219,689.15,2807.996,690.08z M2790.281,819.36c-15.099,1.099-26.874,5.245-35.301,12.446 c-8.441,7.213-12.667,16.906-12.667,29.072c0,11.525,3.909,21.159,11.718,28.893c7.797,7.721,19.89,13.886,36.25,18.493V819.36z  M2821.593,1014.442v98.795c16.414,0.032,29-3.886,37.787-11.746c8.771-7.846,13.151-18.928,13.151-33.256 c0-13.065-4.071-23.899-12.222-32.516C2852.146,1027.09,2839.252,1019.999,2821.593,1014.442z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126288189717554889000000005517510113631162298_",
    gradientUnits: "userSpaceOnUse",
    x1: 2647.3557,
    y1: 881.5538,
    x2: 2950.7883,
    y2: 1525.6833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000126288189717554889000000005517510113631162298_)"
    },
    d: "M2750.664,1038.281 c11.055-109.183,111.399-155.404,98.304-255.836c-8.072-61.9-54.988-114.066-107.325-154.798 c-158.747,16.648-281.501,148.095-281.501,320.018c0,196.331,159.514,360.842,349.732,367.229 c18.469,0.62,36.507-0.34,54.046-2.639C2788.376,1237.083,2741.167,1132.083,2750.664,1038.281z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterOfCredit);
export default __webpack_public_path__ + "static/media/letter-of-credit.b52753364e8981e0032d0f27f299e0a9.svg";
export { ForwardRef as ReactComponent };